export default  {
 "title" : "桐乡",
 "main" : "139", // 实时运营报表
 "daylist" : "69", // 日运营报表
 "monthlist" : "134", // 月运营报表
 "totallist" : "72", // 总运营报表
 "ridelist" : "68", // 骑行运营报表
 "userdatalist" : "40", // 用户数据分析
 "paylist" : "39", // 充值数据分析
 "bikelist" : "38", // 车辆数据分析
 "dashboardno" : "dashboard-1725257393442-468418",
 "projectno" : "proj-xtrace-7e654d5be9aeb17eb6abc78a83f22-cn-hangzhou",
 "customerCensusDay" : "179", // 客服工单统计日报表
 "customerCensusMonth" : "178",   // 客服工单统计月报表
 "customerCensusTime" : "182",  // 客服工单统计时间段
 "siteCensusDay" : "181",  // 站点工单统计日报表
 "siteCensusMonth" : "180",  // 站点工单统计月报表
 "siteCensusTime" : "183", // 站点工单统计时间段报表
 "noPassDetail" : "184",  // 客服审核不通过明细
 "financialmains": "152", // 财务管理
 "agentdayform": "149",  // 代理商日结算报表
 "controlDataAnalyze" : "185",  // 中控数据分析
 "workOrderFaultAnalysis": "202", // 工单故障分析报表
 "LogDashboardno": "dashboard-1614143524253-317785", // 小毛驴用户操作日志
 "ChargingReport": "227", // 换电工作报表
 "bikeAbnormal": "245",  // 车辆异常报表
 "noBoundControlBikeList": "dashboard-1623829284775-275382", // 未绑定中控车辆报表
 "partsMonthlyApplicationReport": "248", // 配件月度申请报表
 "maintainWorkList": "254", // 维修工单统计
 "powerChangeSummary": "251", // 换电工作汇总
 "accessoriesUseReport":"263", // 配件消耗明细报表
 "vehicleAssetsReport": "270", // 车辆资产报表
 "cyclingCardSalesReport":"277", // 骑行卡销售记录
}


// WEBPACK FOOTER //
// ./src/config/tongxiang.js